// extracted by mini-css-extract-plugin
module.exports = {"index":"_38i0Q"};